/**
 * The one place a Discounts DataGrid learns it is running under vitest --
 * phase 6b, Task 7 (from the Task 2 review).
 *
 * MUI X's DataGrid virtualises rows against a measured viewport; jsdom has
 * no layout, so under test every row past the first few is never mounted
 * and `findByText(rowName)` fails. `disableVirtualization` mounts them all.
 * Spread `{...gridTestProps()}` onto every `<DataGrid>` in this area (the
 * promotions list, and Task 3's codes/redemptions grids) instead of
 * repeating the `import.meta.env.MODE` branch inline.
 */
import type { DataGridProps } from '@mui/x-data-grid';

export const gridTestProps = (): Pick<DataGridProps, 'disableVirtualization'> =>
  import.meta.env.MODE === 'test' ? { disableVirtualization: true } : {};
